import Paper, {PaperProps} from '@mui/material/Paper';

import {styled} from '@mui/material/styles';

export const CPaper = styled(Paper)<PaperProps>(
  (/* { theme } */) => ({
  }),
);
